import { getNavActiveIndex } from "../../util/cookie";
export default {
    state: {
        activeIndex: getNavActiveIndex(),
    },
    mutations: {
        SET_HEADER_ACTIVE_INDEX: (state, activeIndex) => {
            state.activeIndex = activeIndex
        },
    },
    actions: {},
    getters: {
        getActiveIndex: state => state.activeIndex,
    }
}


// WEBPACK FOOTER //
// ./src/store/moudles/headNav.js